import { Component, computed, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { EvmPurchseService } from '../../services/evm-services/evm-purchase.service';
import { SwapStatus } from '../../shared/constants/app-enums';

@Component({
    selector: 'app-claim',
    templateUrl: './claim.component.html',
    styleUrls: ['./claim.component.scss'],
    standalone: false
})
export class ClaimComponent {
  SwapStatus = SwapStatus;
  isStake = false;
  lang = 'en';
  isWithdraw = false;

  readonly modalRef = inject(BsModalRef);
  private readonly translate = inject(TranslateService);
  private readonly purchaseService = inject(EvmPurchseService);

  readonly status = computed(() => this.purchaseService.transactionUpdates().status);

  constructor() {
    this.translate.onLangChange.pipe(takeUntilDestroyed()).subscribe((params: LangChangeEvent) => {
      this.lang = params.lang;
    });
  }
}
